<template lang="html">
<div class="subpage addrule_edit">
    <el-form ref="ruleForm" :model="params" :rules="rules" :show-message="true" label-position="right" label-width="120px">
        <!-- 关联账号 -->
        <el-form-item label="关联账号" prop="userId">
            <el-select ref="account" v-model="params.userId" @visible-change="visibleChange" @change="selectChange" clearable filterable remote placeholder="请输入关联账号名称" :remote-method="remoteMethod" :loading="loading">
                <el-option v-for="item in options" :key="item.id" :label="item.account" :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>
        <!-- 姓名 -->
        <el-form-item label="姓名" prop="name">
            <el-input size="medium" v-model="params.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <!-- <el-form-item label="关联栏目" prop="ids">
            <el-cascader ref="cascaderColumn" :options="columnTree" :show-all-levels="true" :props="{ value: 'id', label: 'name', children: 'dtos' ,checkStrictly: true}" :value="ids" @change="selectChange" clearable placeholder="请选择关联栏目"></el-cascader>
        </el-form-item> -->
        <!-- 状态 -->
        <el-form-item label="推广二维码" prop="name">
            <span @click="downloadImg(indata.id)">
                <el-tooltip content="点击下载二维码" placement="top-start">
                    <vue-qr :ref="'Qrcode' + indata.id" :text="urlQrcode(indata)" :margin="10" :size="500" :width="100" />
                </el-tooltip>
            </span>
        </el-form-item>
        <el-form-item label="状态" prop="status">
            <el-radio-group v-model="params.status">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="2">停用</el-radio>
            </el-radio-group>
            &nbsp;&nbsp;&nbsp;&nbsp;停用后，将不在官网上展示，自定义链接不支持访问

        </el-form-item>

    </el-form>
</div>
</template>

<script>
import {
    getUserList,

} from '@/api/pgMent/userMent';
import VueQr from 'vue-qr';
export default {
    props: ['indata'],
    components: {
        VueQr
    },
    data() {
        return {
            options: [],

            params: {
                account: '', //关联账号
                userId: '', //用户ID
                name: '', //姓名
                columnIds: [], //关联栏目
                status: 0, //1启用 2停用
            },
            rules: {
                name: [{
                    required: true,
                    message: '姓名不能为空',
                    trigger: 'blur'
                }],
                userId: [{
                    required: true,
                    message: '关联账号不能为空',
                    trigger: 'blur'
                }],
                status: [{
                    required: true,
                    message: '状态不能为空',
                    trigger: 'blur'
                }, {
                    type: 'number',
                    min: 1,
                    message: '状态必须大于0',
                    trigger: 'blur'
                }],
            }
        }
    },
    watch: {
        indata: function (e) {
            console.log(e);
            var vues=this;
            if (e) {
                for (let key in this.params) {
                    if (e.hasOwnProperty(key)) {
                        this.params[key] = e[key];
                    }
                }
                if (this.params.account) {
                    this.remoteMethod(this.params.account);
                }
                
            }

        }
    },
    methods: {
        visibleChange(e) {
            this.params.account = this.$refs.account.query;
        },

        remoteMethod(query) {
            if (query !== '') {
                this.loading = true;
                var param = {
                    where: query,
                    basePage: {
                        size: 100,
                        no: 1
                    }
                }
                getUserList(param).then(res => {
                    this.options = res.userModules;
                    this.loading = false;
                });
            } else {
                this.options = [];
            }
        },
        imgChange(e) {
            console.log(e);
        },
        saveReturn: function () {
            var vues = this;
            // console.log(this.params);
            return new Promise((reslove, reject) => {

                vues.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        reslove(vues.params);
                    } else {
                        reslove(false);
                    }
                })
            })
        },
        // qrcode(data) {
        //     var domain = 'jingshcqlawyer.com';
        //     console.log('qrcode',data);
        //     if(data.customLink){
        //         domain=data.customLink+'/';
        //     }else{
        //         domain=domain+'/'+data.modelLink+'?id='+data.id;
        //     }
        //     var url='http://'+domain;
        //     this.$refs.qrCodeUrl.innerHTML = ''
        //     new QRCode(this.$refs.qrCodeUrl, {
        //         text: url, // 需要转换为二维码的内容
        //         width: 150,
        //         height: 150,
        //         colorDark: '#000000',
        //         colorLight: '#ffffff',
        //         correctLevel: QRCode.CorrectLevel.H
        //     })
        // },
        downloadImg(link_id) {
            const iconUrl = this.$refs['Qrcode' + link_id].$el.src
            const a = document.createElement('a')
            const event = new MouseEvent('click')
            a.download = link_id
            a.href = iconUrl
            a.dispatchEvent(event)
        },
        urlQrcode(data) {
            var domain = 'jingshcqlawyer.com';
            if (data.customLink) {
                domain = data.customLink + '/';
            } else {
                domain = domain + '/' + data.modelLink + '?id=' + data.id;
            }
            var url = 'http://' + domain;
            return url;
        },
    },
    created: function () {
        var vues = this;
        if (this.indata) {
            for (let key in this.params) {
                if (this.indata.hasOwnProperty(key)) {
                    this.params[key] = this.indata[key];
                }
            }
            console.log(this.indata);
            
        }
    },

}
</script>

<style lang="scss" scoped>
.qrcode{
    display: inline-block;
    img {
        width: 168px;
        height: 168px;
        background-color: #fff; //设置白色背景色
        padding: 6px; // 利用padding的特性，挤出白边
        box-sizing: border-box;
    }
}
</style>

<style lang="css">
.subpage.addrule_edit .el-input__inner {
    border-radius: 0px !important;
}

.subpage.addrule_edit .selects {
    width: 240px !important;
}

.subpage.addrule_edit .el-input {
    width: 240px !important;
}

</style>



// WEBPACK FOOTER //
// subpage1.vue?8f842e4e